import React, { Component } from "react";
import PropTypes from "prop-types";
import FormSkeleton from "../core/FormSkeleton";
import FormDetails from "../core/FormDetails";

class FormPanel extends Component {
  static propTypes = {
    formData: PropTypes.object.isRequired,
    schema: PropTypes.object.isRequired,
    uiSchema: PropTypes.object.isRequired,
    pageContent: PropTypes.object.isRequired
  };

  render() {
    const {
      pageContent,
      formData,
      schema,
      uiSchema,
      onSubmit,
      updateFormData
    } = this.props;

    return (
      <div className="col-md-7 col-xl-8 col-lg-7 col-sm-12">
        <FormDetails pageContent={pageContent} />
        <FormSkeleton
          pageContent={pageContent}
          schema={schema}
          uiSchema={uiSchema}
          formData={formData}
          onSubmit={onSubmit}
          updateFormData={updateFormData}
        />
      </div>
    );
  }
}

FormPanel.propTypes = {};

export default FormPanel;
